/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGrid } from '@mui/x-data-grid';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
} from '@mui/material';
// Components
// API
import {
  postProductAllocationImport,
  getProductAllocationImportLast,
} from '../../../api/productAllocationApi';
// Context
import useProductAllocationContext from '../context/useProductAllocationContext';

export default function ImportModal() {
  const { importModal, setImportModal, handleGenerateFilter } = useContext(
    useProductAllocationContext,
  );

  const importRequestDefault = {
    month_year: moment().format('YYYY-MM'),
    file: null,
  };

  const failedImportDefault = { toggle: false, errors: [] };

  const [importRequest, setImportRequest] = useState(importRequestDefault);
  const [processImport, setProcessImport] = useState(false);
  const [failedImport, setFailedImport] = useState(failedImportDefault);
  const [lastImporDate, setLastImporDate] = useState(null);

  const columns = [
    {
      field: 'row',
      headerName: 'Line #',
      flex: 1,
    },
    {
      field: 'column',
      headerName: 'Error Message',
      flex: 1,
    },
  ];

  const handleCancel = () => {
    setImportModal({ ...importModal, toggle: false });
    setImportRequest(importRequestDefault);
    setFailedImport(failedImportDefault);
  };

  const handleChangeDate = (value) => {
    setImportRequest({ ...importRequest, month_year: moment(value).format('YYYY-MM') });
  };

  const handleChange = (e) => {
    setImportRequest({ ...importRequest, file: e.target.files[0] });
  };

  const handleLastImportUpdate = async () => {
    try {
      const response = await getProductAllocationImportLast();
      const { code, data } = response.data;

      if (code === '200') {
        setLastImporDate({
          ...lastImporDate,
          last_upadate: moment(data?.uploaded_at).format('MM-DD-YYYY'),
          effective_date: moment()
            .month(data?.month - 1)
            .format('MMMM'),
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSubmitImport = async () => {
    try {
      setProcessImport(true);
      const request = {
        file: importRequest?.file,
        month: moment(importRequest?.month_year).format('MM'),
        year: moment(importRequest?.month_year).format('YYYY'),
      };

      const response = await postProductAllocationImport(request);
      const { code, data } = response.data;

      if (code === '400') {
        if (data?.file) {
          Swal.fire({
            title: 'Invalid Request',
            html: data?.file?.join('<br />'),
            icon: 'warning',
          });
        } else {
          setFailedImport({
            ...failedImport,
            toggle: true,
            errors: data,
          });
        }
        setProcessImport(false);
        return;
      }

      toast.success('File has been successfully uploaded');
      setProcessImport(false);
      setImportRequest(importRequestDefault);
      setFailedImport(failedImportDefault);
      handleCancel();
      handleGenerateFilter();
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleLastImportUpdate();
  }, []);

  return (
    <div>
      <Dialog open={importModal?.toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
        <DialogTitle>Product Sample Allocation Import</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid xs={12} md={12} lg={12} sx={{ padding: 2 }}>
              <Box sx={{ fontWeight: 'bold', color: 'red' }}>
                {' '}
                Last Imported Date: {lastImporDate?.last_upadate}
              </Box>

              <Box sx={{ fontWeight: 'bold', color: 'red' }}>
                {' '}
                Effectivity Month: {lastImporDate?.effective_date}
              </Box>
            </Grid>
            <Grid xs={12} md={12} lg={12}>
              <DatePicker
                label='month_year'
                views={['month', 'year']}
                value={importRequest?.month_year}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => (
                  <TextField {...params} label='Month Year' size='small' fullWidth />
                )}
                onChange={(value) => handleChangeDate(value)}
              />
            </Grid>
            <Grid xs={12} md={12} lg={12}>
              <Box component='form' noValidate autoComplete='off'>
                <TextField
                  type='file'
                  id='file'
                  name='file'
                  onChange={(e) => handleChange(e)}
                  size='small'
                  fullWidth
                  style={{ marginTop: '10px' }}
                />
              </Box>
            </Grid>
            {failedImport?.toggle ? (
              <Grid xs={12} md={12} lg={12}>
                <DataGrid
                  autoHeight
                  rows={failedImport?.errors}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                />
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='success' onClick={handleSubmitImport}>
            Import
          </Button>
          <Button variant='contained' color='error' onClick={handleCancel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{ color: '#fff', zIndex: '9999' }} open={processImport}>
        <CircularProgress color='inherit' />
        <Typography position='absolute' sx={{ marginTop: '100px' }}>
          Processing import please do not refresh the page...
        </Typography>
      </Backdrop>
    </div>
  );
}
